import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGlobalQueryLoading } from '@vue/apollo-composable';
import { toNumber } from 'lodash';
import { editablePaiReportForm } from '~/assets/fund/paiReport';
import { renderTrustedMarkdown } from '~/functions/markdown';
import { getNestedProperty } from '~/functions/sfdr';
import { ReportType, useGetAccountQuery, useGetFundQuery, useGetPaiReportQuery, useListReferencePeriodsQuery, useUpdateReportAnswerMutation } from '~/types/types';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'pai',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetFundQuery = useGetFundQuery({
        id: toNumber(route.params.fund)
      }),
      result = _useGetFundQuery.result;
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var fund = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getFund;
    });
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var paiMetricIds = computed(function () {
      var _fund$value$socialMet, _fund$value, _fund$value$environme, _fund$value2;
      var socialMetrics = (_fund$value$socialMet = (_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : _fund$value.socialMetricIds) !== null && _fund$value$socialMet !== void 0 ? _fund$value$socialMet : [];
      var environmentalMetrics = (_fund$value$environme = (_fund$value2 = fund.value) === null || _fund$value2 === void 0 ? void 0 : _fund$value2.environmentalMetricIds) !== null && _fund$value$environme !== void 0 ? _fund$value$environme : [];
      return [].concat(_toConsumableArray(socialMetrics), _toConsumableArray(environmentalMetrics));
    });
    var _useUpdateReportAnswe = useUpdateReportAnswerMutation(),
      updateReportAnswer = _useUpdateReportAnswe.mutate;
    var fetchedCurrentUserInputObject = computed(function () {
      var _fund$value3, _fund$value3$paiAnswe, _answer$reportData;
      var answer = (_fund$value3 = fund.value) === null || _fund$value3 === void 0 ? void 0 : (_fund$value3$paiAnswe = _fund$value3.paiAnswers) === null || _fund$value3$paiAnswe === void 0 ? void 0 : _fund$value3$paiAnswe.find(function (answer) {
        return answer.referencePeriodId === Number(route.query.referencePeriodId);
      });
      return (_answer$reportData = answer === null || answer === void 0 ? void 0 : answer.reportData) !== null && _answer$reportData !== void 0 ? _answer$reportData : {};
    });
    var localPaiReportData = ref({});
    var currentUserInputObject = computed(function () {
      return _objectSpread(_objectSpread({}, fetchedCurrentUserInputObject.value), localPaiReportData.value);
    });
    var _useListReferencePeri = useListReferencePeriodsQuery({
        filters: {
          isAnnual: true,
          userDefined: false
        },
        sort: 'asc'
      }),
      prevYearsRefPeriodResult = _useListReferencePeri.result;
    var referencePeriods = computed(function () {
      var _prevYearsRefPeriodRe, _prevYearsRefPeriodRe2;
      return (_prevYearsRefPeriodRe = (_prevYearsRefPeriodRe2 = prevYearsRefPeriodResult.value) === null || _prevYearsRefPeriodRe2 === void 0 ? void 0 : _prevYearsRefPeriodRe2.listReferencePeriods) !== null && _prevYearsRefPeriodRe !== void 0 ? _prevYearsRefPeriodRe : [];
    });
    var previousReferencePeriod = computed(function () {
      var _periods;
      // find the index for route.query.referencePeriodId using period.id
      // Then grab the previous index using index -1 (since it is sorted in ascending)
      var periods = referencePeriods.value;
      if (!periods || periods.length === 0) return null;
      var currentId = parseInt(route.query.referencePeriodId);
      var currentIndex = periods.findIndex(function (period) {
        return period.id === currentId;
      });

      // Return null if current period not found or if it's the first period
      if (currentIndex <= 0) return null;
      return (_periods = periods[currentIndex - 1]) !== null && _periods !== void 0 ? _periods : null;
    });
    var currentReferencePeriod = computed(function () {
      var _periods$find;
      var periods = referencePeriods.value;
      if (!periods || periods.length === 0) return null;
      var currentId = parseInt(route.query.referencePeriodId);
      return (_periods$find = periods.find(function (period) {
        return period.id === currentId;
      })) !== null && _periods$find !== void 0 ? _periods$find : null;
    });
    var previousUserInputObject = computed(function () {
      var _previousReferencePer, _fund$value4, _fund$value4$paiAnswe, _answer$reportData2;
      var prevPeriodId = (_previousReferencePer = previousReferencePeriod.value) === null || _previousReferencePer === void 0 ? void 0 : _previousReferencePer.id;
      if (!prevPeriodId) return {};
      var answer = (_fund$value4 = fund.value) === null || _fund$value4 === void 0 ? void 0 : (_fund$value4$paiAnswe = _fund$value4.paiAnswers) === null || _fund$value4$paiAnswe === void 0 ? void 0 : _fund$value4$paiAnswe.find(function (answer) {
        return answer.referencePeriodId === String(prevPeriodId);
      });
      return (_answer$reportData2 = answer === null || answer === void 0 ? void 0 : answer.reportData) !== null && _answer$reportData2 !== void 0 ? _answer$reportData2 : {};
    });
    var triggerUpdateReportAnswer = function triggerUpdateReportAnswer(key, val) {
      var _fund$value5;
      localPaiReportData.value = _objectSpread(_objectSpread({}, localPaiReportData.value), {}, _defineProperty({}, key, val === undefined || val === '' ? null : val));
      var input = {
        fundId: (_fund$value5 = fund.value) === null || _fund$value5 === void 0 ? void 0 : _fund$value5.id,
        referencePeriodId: Number(route.query.referencePeriodId),
        reportType: ReportType.SfdrPai,
        paiReportData: _defineProperty({}, key, val === undefined || val === '' ? null : val)
      };
      updateReportAnswer({
        input: input
      });
    };
    var updatePaiInfoItem = function updatePaiInfoItem(key, val, metricId) {
      var update = {};
      update[metricId] = _defineProperty({}, key, val === undefined || val === '' ? null : val);
      triggerUpdateReportAnswer('principalAdverseImpactsExplanationsAndActions', update);
    };
    var _useGetPaiReportQuery = useGetPaiReportQuery(computed(function () {
        return {
          input: {
            id: toNumber(route.params.fund),
            referencePeriodId: toNumber(route.query.referencePeriodId)
          }
        };
      }), computed(function () {
        return {
          enabled: Boolean(toNumber(route.params.fund)) && Boolean(toNumber(route.query.referencePeriodId))
        };
      })),
      calculatedPaiReportResult = _useGetPaiReportQuery.result;
    var calculatedPaiReport = computed(function () {
      var _calculatedPaiReportR;
      return ((_calculatedPaiReportR = calculatedPaiReportResult.value) === null || _calculatedPaiReportR === void 0 ? void 0 : _calculatedPaiReportR.getPaiReport) || null;
    });
    var loading = useGlobalQueryLoading();
    var locale = computed(function () {
      return getLocale();
    });

    // Static form data
    var form = editablePaiReportForm;
    return {
      __sfc: true,
      route: route,
      result: result,
      accountResult: accountResult,
      fund: fund,
      account: account,
      paiMetricIds: paiMetricIds,
      updateReportAnswer: updateReportAnswer,
      fetchedCurrentUserInputObject: fetchedCurrentUserInputObject,
      localPaiReportData: localPaiReportData,
      currentUserInputObject: currentUserInputObject,
      prevYearsRefPeriodResult: prevYearsRefPeriodResult,
      referencePeriods: referencePeriods,
      previousReferencePeriod: previousReferencePeriod,
      currentReferencePeriod: currentReferencePeriod,
      previousUserInputObject: previousUserInputObject,
      triggerUpdateReportAnswer: triggerUpdateReportAnswer,
      updatePaiInfoItem: updatePaiInfoItem,
      calculatedPaiReportResult: calculatedPaiReportResult,
      calculatedPaiReport: calculatedPaiReport,
      loading: loading,
      locale: locale,
      form: form,
      renderTrustedMarkdown: renderTrustedMarkdown,
      getNestedProperty: getNestedProperty
    };
  }
});